/**
 * Natural Nutrients: Cart Drawer Upsell
 * cart-upsell.js
 *
 * To customise: edit the CONFIG block only.
 *
 * 2026-10-05 changes:
 * - Cross-sells default to a sensible size (never the most expensive variant).
 * - Creatine ladder: 150g -> 300g upgrade, Whey Isolate (300g default, sample in the menu), ZMA, then the scoop.
 * - "Subscribe and save" switch on one-time lines (not samples or scoops).
 * - Add-ons follow the cart: if the cart already has a subscription, subscribable
 *   add-ons join it on the same plan.
 * - Empty cart shows suggestions, the quiz and the subscribe offer.
 * - Delivery bar only shows once free delivery is within reach.
 */

(function () {
  'use strict';

  var CONFIG = {
    freeDeliveryThreshold: 10000,   /* pence: matches the UK free-shipping rate */
    deliveryFromText: '£3.49',      /* cheapest UK rate, shown until the bar is within reach */
    quizUrl: '/pages/supplement-quiz',

    handles: {
      creatine:         'creapure-creatine-monohydrate-powder',
      wheyIsolate:      'grass-fed-whey-protein-isolate',
      wheyConcentrate:  'grass-fed-whey-protein-concentrate',
      veganVanilla:     'vegan-protein-powder-vanilla',
      veganChocolate:   'vegan-protein-powder-chocolate',
      supremeGreens:    'supreme-greens-powder-drink',
      digestiveEnzymes: 'natural-digestive-enzyme-complex-capsules',
      probiotics:       'probiotic-complex-10bn-cfu-high-strength',
      zma:              'zma-supplement-zinc-and-magnesium',
      magnesium:        'super-magnesium-citrate-bisglycinate-capsules',
      omega3:           'high-strength-optomega-3-fish-oil-capsules',
      brainPower:       'brain-power-natural-nootropic',
      zinc:             'zinc-citrate-supplement-15mg',
      vitaminD:         'vegan-vitamin-d3-capsules',
      wheySampleBox:    'whey-protein-sample-box',
      scoop:            'beech-measuring-scoop',
    },

    /* Default variant per product: first variant whose title contains this text.
       Anything not listed defaults to the cheapest full-size variant. */
    preferredVariant: {
      'grass-fed-whey-protein-isolate':       '300g',
      'grass-fed-whey-protein-concentrate':   '300g',
      'creapure-creatine-monohydrate-powder': '300g',
    },

    /* Default flavour on cart and empty-cart cards (the shopper can still change it). */
    preferredFlavour: {
      'grass-fed-whey-protein-isolate':     'Vanilla',
      'grass-fed-whey-protein-concentrate': 'Vanilla',
    },

    /* Never offered as a subscription in the cart. Matched against product titles. */
    noSubscribeKeywords: ['sample', 'scoop', 'shaker'],

    /* Plan used by the "Subscribe and save" switch (matched by name, case-insensitive). */
    subscribePlanName: 'monthly subscription',

    /* Empty cart suggestions: handle + size filter (option value text) */
    emptySuggestions: [
      { handle: 'grass-fed-whey-protein-isolate',       size: '300g' },
      { handle: 'creapure-creatine-monohydrate-powder', size: '300g' },
      { handle: 'grass-fed-whey-protein-isolate',       size: '30g', label: 'Whey Isolate sample (30g)' },
    ],

    heading: 'You might also want',

    red:    '#AB5153',
    dark:   '#1B2121',
    body:   '#68605A',
    off:    '#F2F2F2',
    border: '#E5E5E5',
    white:  '#FFFFFF',
    green:  '#3d7a45',
  };

  var isOurUpdate = false;

  function injectStyles() {
    if (document.getElementById('nn-upsell-css')) return;
    var css = [
      '.nn-items { list-style:none; margin:0; padding:0; }',
      '.nn-item { display:flex; gap:14px; padding:16px 20px; border-bottom:1px solid ' + CONFIG.border + '; }',
      '.nn-item__img-wrap { width:70px; height:70px; flex-shrink:0; border-radius:8px; overflow:hidden; background:' + CONFIG.off + '; }',
      '.nn-item__img { width:100%; height:100%; object-fit:contain; display:block; }',
      '.nn-item__body { flex:1; min-width:0; }',
      '.nn-item__title { font-size:13px; font-weight:600; color:' + CONFIG.dark + '; margin:0 0 2px; line-height:1.3; }',
      '.nn-item__variant { font-size:12px; color:' + CONFIG.body + '; margin:0 0 6px; }',
      '.nn-item__plan { font-size:11px; font-weight:600; color:' + CONFIG.green + '; margin:0 0 6px; }',
      '.nn-item__discount-label { font-size:11px; font-weight:600; color:' + CONFIG.green + '; margin:0 0 6px; }',
      '.nn-item__row { display:flex; justify-content:space-between; align-items:center; }',
      '.nn-item__qty { display:flex; align-items:center; border:1px solid ' + CONFIG.border + '; border-radius:99px; overflow:hidden; }',
      '.nn-item__qty-btn { background:none; border:none; width:30px; height:28px; cursor:pointer; font-size:16px; color:' + CONFIG.dark + '; font-family:inherit; display:flex; align-items:center; justify-content:center; transition:background 0.15s; }',
      '.nn-item__qty-btn:hover { background:' + CONFIG.off + '; }',
      '.nn-item__qty-btn:disabled { opacity:0.35; cursor:not-allowed; }',
      '.nn-item__qty-num { font-size:13px; font-weight:600; color:' + CONFIG.dark + '; min-width:24px; text-align:center; }',
      '.nn-item__price-wrap { text-align:right; }',
      '.nn-item__price { font-size:13px; font-weight:600; color:' + CONFIG.dark + '; }',
      '.nn-item__price--was { font-size:12px; font-weight:400; color:' + CONFIG.body + '; text-decoration:line-through; margin-right:2px; }',
      '.nn-item__price--now { font-size:13px; font-weight:600; color:' + CONFIG.dark + '; }',
      '.nn-item__price--saving { display:block; font-size:11px; font-weight:600; color:' + CONFIG.green + '; margin-top:2px; }',
      '.nn-item__links { display:flex; gap:14px; align-items:center; margin-top:6px; flex-wrap:wrap; }',
      '.nn-item__remove { background:none; border:none; cursor:pointer; font-size:11px; color:' + CONFIG.body + '; padding:0; font-family:inherit; text-decoration:underline; opacity:0.7; }',
      '.nn-item__remove:hover { opacity:1; }',
      '.nn-item__sub { background:none; border:1px solid ' + CONFIG.red + '; color:' + CONFIG.red + '; border-radius:99px; padding:5px 11px; font-size:11px; font-weight:700; cursor:pointer; font-family:inherit; line-height:1.2; }',
      '.nn-item__sub:hover { background:' + CONFIG.red + '; color:' + CONFIG.white + '; }',
      '.nn-item__sub:disabled { opacity:0.55; cursor:not-allowed; }',
      '[data-subtotal] { display:block; }',
      '.nn-sub__was { font-size:12px; font-weight:400; color:' + CONFIG.body + '; text-decoration:line-through; margin-right:4px; }',
      '.nn-sub__saving { display:block; font-size:12px; font-weight:600; color:' + CONFIG.green + '; margin-top:2px; }',
      '#nn-cart-upsell { font-family:inherit; border-top:1px solid ' + CONFIG.border + '; }',
      /* The theme re-renders its own line items into the drawer on every change.
         Hide them: this script draws the items itself, so they only ever flashed. */
      '#CartDrawer [data-products] .cart__item, #CartDrawer [data-products] .cart__items { display:none !important; }',
      /* The theme's sticky header sits at z-index 400, above the cart drawer (30), so on
         mobile it covered the top of the open drawer and swallowed scrolling. Drop the
         header below the drawer only while the cart drawer is open. */
      'html:has(#CartDrawer.drawer--is-open) .site-header { z-index:20 !important; }',
      /* At the top of the page the theme starts the drawer below the header (top:~180px),
         which is the strip the header then covered. Run it full height instead. */
      '#CartDrawer.drawer--cart { top:0 !important; height:100% !important; max-height:none !important; }',
      /* Let the empty-cart suggestions scroll on short screens */
      '#CartDrawer.is-empty .drawer__contents { display:flex; flex-direction:column; height:100%; }',
      '#CartDrawer.is-empty .drawer__cart-empty { flex:1 1 auto; min-height:0; overflow-y:auto; -webkit-overflow-scrolling:touch; }',
      '.nn-up__progress { padding:18px 20px 14px; }',
      '.nn-up__progress-label { font-size:13px; color:' + CONFIG.body + '; margin:0 0 10px; line-height:1.4; display:block; }',
      '.nn-up__progress-label strong { color:' + CONFIG.dark + '; font-weight:600; }',
      '.nn-up__progress-sub { display:block; font-size:11px; color:' + CONFIG.body + '; margin-top:7px; }',
      '.nn-up__progress-label.nn-up__unlocked { color:' + CONFIG.green + '; font-weight:600; }',
      '.nn-up__delivery { padding:14px 20px 4px; font-size:12px; color:' + CONFIG.body + '; }',
      '.nn-up__track { height:5px; background:' + CONFIG.border + '; border-radius:99px; overflow:hidden; }',
      '.nn-up__bar { height:100%; background:' + CONFIG.red + '; border-radius:99px; transition:width 0.5s ease; }',
      '.nn-up__bar.nn-up__bar--full { background:' + CONFIG.green + '; }',
      '.nn-up__section { padding:12px 20px 18px; }',
      '.nn-up__heading { font-size:11px; font-weight:700; letter-spacing:0.12em; text-transform:uppercase; color:' + CONFIG.body + '; margin:0 0 10px; }',
      '.nn-up__cards { display:flex; flex-direction:column; gap:10px; }',
      '.nn-up__card { display:flex; align-items:center; gap:14px; background:' + CONFIG.off + '; border-radius:14px; border:1.5px solid transparent; padding:12px 14px 12px 10px; }',
      '.nn-up__card--upgrade { background:' + CONFIG.white + '; border-color:' + CONFIG.red + '; }',
      '.nn-up__img-wrap { width:64px; height:64px; flex-shrink:0; border-radius:8px; background:' + CONFIG.white + '; overflow:hidden; display:flex; align-items:center; justify-content:center; }',
      '.nn-up__img { width:100%; height:100%; object-fit:contain; }',
      '.nn-up__card-body { flex:1; min-width:0; }',
      '.nn-up__card-name { font-size:13px; font-weight:600; color:' + CONFIG.dark + '; margin:0 0 2px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; line-height:1.3; }',
      '.nn-up__card-price { font-size:12px; color:' + CONFIG.body + '; margin:0 0 8px; }',
      '.nn-up__note { font-size:11px; font-weight:600; color:' + CONFIG.red + '; margin:0 0 8px; line-height:1.35; }',
      '.nn-up__btn { display:inline-block; background:' + CONFIG.dark + '; color:' + CONFIG.white + '; border:none; border-radius:99px; padding:8px 16px; font-size:12px; font-weight:600; cursor:pointer; font-family:inherit; line-height:1; transition:background 0.2s; white-space:nowrap; }',
      '.nn-up__btn:hover { background:#495959; }',
      '.nn-up__btn--red { background:' + CONFIG.red + '; }',
      '.nn-up__btn--red:hover { background:#8a3f41; }',
      '.nn-up__btn:disabled { opacity:0.55; cursor:not-allowed; }',
      '.nn-up__actions { display:flex; align-items:center; gap:10px; flex-wrap:wrap; }',
      '.nn-up__once { background:none; border:none; padding:4px 2px; font:inherit; font-size:12px; font-weight:600; color:' + CONFIG.dark + '; text-decoration:underline; cursor:pointer; }',
      '.nn-up__once:disabled { opacity:.55; cursor:not-allowed; }',
      '.nn-up__price-sub { color:' + CONFIG.dark + '; font-weight:700; }',
      '.nn-up__price-was { color:' + CONFIG.body + '; margin-left:2px; }',
      '.nn-up__view { font-size:11px; font-weight:600; color:' + CONFIG.body + '; text-decoration:underline; white-space:nowrap; flex-shrink:0; }',
      '.nn-up__view:hover { color:' + CONFIG.dark + '; }',
      '.nn-up__selectors { display:flex; flex-wrap:wrap; gap:6px; margin-bottom:8px; }',
      '.nn-up__select { -webkit-appearance:none; appearance:none; background:' + CONFIG.white + '; border:1px solid ' + CONFIG.border + '; border-radius:99px; padding:5px 24px 5px 10px; font-size:11px; font-family:inherit; color:' + CONFIG.dark + '; cursor:pointer; background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'10\' height=\'6\'%3E%3Cpath d=\'M1 1l4 4 4-4\' stroke=\'%2368605A\' stroke-width=\'1.5\' fill=\'none\' stroke-linecap=\'round\'/%3E%3C/svg%3E"); background-repeat:no-repeat; background-position:right 8px center; }',
      '.nn-up__select:focus { outline:none; border-color:' + CONFIG.dark + '; }',
      '.nn-empty { padding:28px 20px 24px; text-align:left; }',
      '.nn-empty__title { font-size:17px; font-weight:700; color:' + CONFIG.dark + '; margin:0 0 4px; text-align:center; }',
      '.nn-empty__lead { font-size:13px; color:' + CONFIG.body + '; margin:0 0 18px; text-align:center; line-height:1.45; }',
      '.nn-empty__lead a { color:' + CONFIG.dark + '; font-weight:600; text-decoration:underline; }',
      '.nn-empty__sub { margin:16px 0 0; padding:12px 14px; border-radius:12px; background:#F7EEEE; color:' + CONFIG.dark + '; font-size:12px; line-height:1.45; text-align:center; }',
      '.nn-empty__sub strong { color:' + CONFIG.red + '; }',
      '.cart__empty-text .nn-empty { max-width:460px; margin:0 auto; }',
      '@media (max-height:700px) {',
      '  .nn-up__progress { padding:12px 20px 10px; }',
      '  .nn-up__section { padding:8px 20px 12px; }',
      '  .nn-up__cards { gap:7px; }',
      '  .nn-up__card { padding:9px 12px 9px 8px; gap:10px; }',
      '  .nn-up__img-wrap { width:48px; height:48px; }',
      '  .nn-up__card-name { font-size:12px; }',
      '  .nn-up__card-price,.nn-up__note { font-size:11px; margin-bottom:6px; }',
      '  .nn-up__btn { padding:6px 12px; font-size:11px; }',
      '  .nn-item { padding:12px 16px; gap:10px; }',
      '  .nn-item__img-wrap { width:54px; height:54px; }',
      '}',
    ].join('\n');

    var el = document.createElement('style');
    el.id  = 'nn-upsell-css';
    el.textContent = css;
    document.head.appendChild(el);
  }

  function formatMoney(pence) {
    return '£' + (pence / 100).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  var productCache = {};

  function getCart() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function getProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  /* ---------- variants ---------- */

  function variantsFor(product, sizeFilter) {
    if (!sizeFilter) return product.variants.slice();
    var f = sizeFilter.toLowerCase();
    var list = product.variants.filter(function (v) { return (v.title || '').toLowerCase().indexOf(f) !== -1; });
    return list.length ? list : product.variants.slice();
  }

  function isSampleSize(v) {
    return /(^|\s|\/)30g(\s|$)/i.test(v.title || '');
  }

  /* Previously this returned the MOST EXPENSIVE available variant, which offered
     a creatine buyer the 2kg whey isolate at £143.99. Now: an explicit preference,
     else the cheapest available full-size variant. */
  function getDefaultVariant(product, sizeFilter) {
    var pool = variantsFor(product, sizeFilter);
    var avail = pool.filter(function (v) { return v.available; });
    if (!avail.length) avail = pool;

    var flav = CONFIG.preferredFlavour[product.handle];
    if (flav) {
      var inFlav = avail.filter(function (v) { return (v.title || '').indexOf(flav) !== -1; });
      if (inFlav.length) avail = inFlav;
    }

    var pref = !sizeFilter && CONFIG.preferredVariant[product.handle];
    if (pref) {
      var hit = avail.filter(function (v) { return (v.title || '').toLowerCase().indexOf(pref.toLowerCase()) !== -1; })[0];
      if (hit) return hit;
    }
    var full = sizeFilter ? avail : avail.filter(function (v) { return !isSampleSize(v); });
    if (!full.length) full = avail;
    full.sort(function (a, b) { return a.price - b.price; });
    return full[0];
  }

  function findVariantByOptions(product, opts, sizeFilter) {
    return variantsFor(product, sizeFilter).filter(function (v) {
      return opts.every(function (val, i) { return v['option' + (i + 1)] === val; });
    })[0] || null;
  }

  function getOptionGroups(product, sizeFilter) {
    if (!product.options) return [];
    var pool = variantsFor(product, sizeFilter);
    var groups = [];
    product.options.forEach(function (opt, i) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var seen = {}, values = [];
      pool.forEach(function (v) {
        var val = v['option' + (i + 1)];
        if (!seen[val]) {
          seen[val] = true;
          var avail = pool.some(function (v2) { return v2['option' + (i + 1)] === val && v2.available; });
          values.push({ value: val, available: avail });
        }
      });
      if (values.length > 1) groups.push({ name: name, index: i, values: values });
    });
    return groups;
  }

  /* ---------- subscriptions ---------- */

  function canSubscribe(title, variantTitle) {
    var t = (title || '').toLowerCase();
    if (variantTitle && /(^|[^0-9])30g\b/i.test(variantTitle)) return false;   /* 30g sample sizes */
    return !CONFIG.noSubscribeKeywords.some(function (k) { return t.indexOf(k) !== -1; });
  }

  function findPlan(product, planName) {
    if (!product || !product.selling_plan_groups) return null;
    var want = (planName || '').toLowerCase();
    var found = null;
    product.selling_plan_groups.forEach(function (g) {
      (g.selling_plans || []).forEach(function (p) {
        if (!found && (p.name || '').toLowerCase() === want) found = p;
      });
    });
    return found;
  }

  function planPercent(plan) {
    var adj = plan && plan.price_adjustments && plan.price_adjustments[0];
    return adj && adj.value_type === 'percentage' ? adj.value : 0;
  }

  /* The plan already used in the cart, if any (so add-ons can join it). */
  function cartPlanName(cart) {
    var name = null;
    (cart.items || []).forEach(function (item) {
      if (!name && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        name = item.selling_plan_allocation.selling_plan.name;
      }
    });
    return name;
  }

  /* Keeps the theme's own empty/non-empty state in sync with the real cart.
     "cart--empty" on the forms and "is-empty" on #CartDrawer are set at server
     render and never touched client-side by the theme, so re-apply on every refresh. */
  function syncEmptyState(cart) {
    var isEmpty = (cart.items || []).length === 0;
    ['CartDrawerForm', 'CartPageForm'].forEach(function (id) {
      var form = document.getElementById(id);
      if (form) form.classList.toggle('cart--empty', isEmpty);
    });
    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.classList.toggle('is-empty', isEmpty);
  }

  /* ---------- cart lines ---------- */

  function renderCartItems(cart) {
    var container = document.querySelector('[data-products]');
    var items = cart.items || [];

    if (items.length === 0) {
      if (container) container.innerHTML = '';
      updateSubtotalDisplay(cart);
      renderEmpty();
      return;
    }
    if (!container) return;

    var html = '<ul class="nn-items">';
    items.forEach(function (item) {
      var imgHtml = item.image
        ? '<img src="' + esc(item.image) + '" alt="' + esc(item.product_title) + '" class="nn-item__img" loading="lazy">'
        : '';

      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="nn-item__variant">' + esc(item.variant_title) + '</p>' : '';

      var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
      var planHtml = plan
        ? '<p class="nn-item__plan">Subscribe and save: ' + esc(plan.name.replace(/ subscription$/i, '').toLowerCase()) + ' delivery</p>'
        : '';

      var lineDiscount = item.original_line_price - item.line_price;
      var priceHtml;
      if (lineDiscount > 0) {
        priceHtml = '<span class="nn-item__price--was">' + formatMoney(item.original_line_price) + '</span>'
          + '<span class="nn-item__price--now">' + formatMoney(item.line_price) + '</span>'
          + '<span class="nn-item__price--saving">Save ' + formatMoney(lineDiscount) + '</span>';
      } else {
        priceHtml = '<span class="nn-item__price">' + formatMoney(item.line_price) + '</span>';
      }

      var discountLabel = '';
      if (item.discount_allocations && item.discount_allocations.length) {
        var titles = item.discount_allocations
          .filter(function (d) { return d.discount_application && d.discount_application.title; })
          .map(function (d) { return d.discount_application.title; });
        if (titles.length) discountLabel = '<p class="nn-item__discount-label">' + esc(titles[0]) + '</p>';
      }

      /* Placeholder filled once the product's plans are known */
      var subSlot = (!plan && canSubscribe(item.product_title, item.variant_title))
        ? '<span data-nn-sub-slot data-key="' + item.key + '" data-handle="' + esc(item.handle) + '" data-qty="' + item.quantity + '" data-line-price="' + item.line_price + '" data-original-price="' + item.original_line_price + '"></span>'
        : '';

      html += '<li class="nn-item" data-key="' + item.key + '">'
        + '<div class="nn-item__img-wrap">' + imgHtml + '</div>'
        + '<div class="nn-item__body">'
        + '<p class="nn-item__title">' + esc(item.product_title) + '</p>'
        + variantHtml
        + planHtml
        + discountLabel
        + '<div class="nn-item__row">'
        + '<div class="nn-item__qty">'
        + '<button type="button" class="nn-item__qty-btn" data-nn-qty data-key="' + item.key + '" data-delta="-1" aria-label="Decrease quantity">&#8722;</button>'
        + '<span class="nn-item__qty-num">' + item.quantity + '</span>'
        + '<button type="button" class="nn-item__qty-btn" data-nn-qty data-key="' + item.key + '" data-delta="1" aria-label="Increase quantity">&#43;</button>'
        + '</div>'
        + '<div class="nn-item__price-wrap">' + priceHtml + '</div>'
        + '</div>'
        + '<div class="nn-item__links">' + subSlot
        + '<button type="button" class="nn-item__remove" data-nn-remove data-key="' + item.key + '">Remove</button></div>'
        + '</div></li>';
    });
    html += '</ul>';

    container.innerHTML = html;
    updateSubtotalDisplay(cart);
    clearEmpty();

    container.querySelectorAll('[data-nn-qty]').forEach(function (btn) {
      btn.addEventListener('click', handleQtyChange);
    });
    container.querySelectorAll('[data-nn-remove]').forEach(function (btn) {
      btn.addEventListener('click', handleRemove);
    });
    fillSubscribeSwitches(container);
  }

  function fillSubscribeSwitches(container) {
    container.querySelectorAll('[data-nn-sub-slot]').forEach(function (slot) {
      var handle = slot.getAttribute('data-handle');
      getProduct(handle).then(function (product) {
        var plan = findPlan(product, CONFIG.subscribePlanName);
        if (!plan || !slot.isConnected) return;
        /* Real saving: subscription price vs what the line costs now. Codes such as
           WELCOME10 do not stack with the subscription discount, so a 10% plan can
           save nothing over a 10% code. Only offer the switch when it saves money. */
        var pct = planPercent(plan);
        var linePrice = parseInt(slot.getAttribute('data-line-price'), 10);
        var original = parseInt(slot.getAttribute('data-original-price'), 10) || linePrice;
        var saving = pct ? linePrice - Math.round(original * (100 - pct) / 100) : 0;
        if (saving < 10) { slot.remove(); return; }
        var label = 'Subscribe and save ' + formatMoney(saving);
        slot.outerHTML = '<button type="button" class="nn-item__sub" data-nn-subscribe data-key="' + slot.getAttribute('data-key') + '"'
          + ' data-qty="' + slot.getAttribute('data-qty') + '" data-plan="' + plan.id + '"'
          + ' title="Delivered monthly. Skip or cancel any time from your account.">' + label + '</button>';
        var btn = container.querySelector('[data-nn-subscribe][data-key="' + slot.getAttribute('data-key') + '"]');
        if (btn) btn.addEventListener('click', handleSubscribeSwitch);
      });
    });
  }

  function handleSubscribeSwitch(e) {
    var btn = e.currentTarget;
    btn.disabled = true;
    btn.textContent = 'Switching...';
    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({
        id: btn.getAttribute('data-key'),
        quantity: parseInt(btn.getAttribute('data-qty'), 10),
        selling_plan: parseInt(btn.getAttribute('data-plan'), 10),
      }),
    })
    .then(function (r) { if (!r.ok) throw new Error(); return fullRefresh(); })
    .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
  }

  function updateSubtotalDisplay(cart) {
    var subtotalEl = document.querySelector('[data-subtotal]');
    if (!subtotalEl) return;

    isOurUpdate = true;

    var totalDiscount = cart.total_discount || 0;
    if (totalDiscount > 0) {
      subtotalEl.innerHTML = '<s class="nn-sub__was">' + formatMoney(cart.original_total_price) + '</s> '
        + formatMoney(cart.total_price)
        + '<span class="nn-sub__saving">You save ' + formatMoney(totalDiscount) + '</span>';
    } else {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    var discountsEl = document.querySelector('[data-discounts]');
    if (discountsEl) {
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
        discountsEl.innerHTML = cart.cart_level_discount_applications.map(function (d) {
          return '<div class="cart__item-sub cart__item-row"><div>' + esc(d.title) + '</div><div>-' + formatMoney(d.total_allocated_amount) + '</div></div>';
        }).join('');
      } else {
        discountsEl.innerHTML = '';
      }
    }

    setTimeout(function () { isOurUpdate = false; }, 100);
  }

  /* ---------- empty cart ---------- */

  function clearEmpty() {
    document.querySelectorAll('[data-nn-empty]').forEach(function (el) { el.innerHTML = ''; });
  }

  function renderEmpty() {
    var targets = document.querySelectorAll('[data-nn-empty]');
    if (!targets.length) return;

    Promise.all(CONFIG.emptySuggestions.map(function (s) {
      return getProduct(s.handle).then(function (p) { return { s: s, product: p }; });
    })).then(function (results) {
      var cards = results.filter(function (r) { return r.product; }).map(function (r) {
        return buildCard({ type: 'cross', handle: r.s.handle, size: r.s.size, label: r.s.label }, r.product, null);
      }).join('');

      var html = '<div class="nn-empty">'
        + '<p class="nn-empty__title">Your cart is empty</p>'
        + '<p class="nn-empty__lead">Not sure where to start? <a href="' + CONFIG.quizUrl + '">Take the quiz</a> or pick up a favourite.</p>'
        + '<div class="nn-up__cards">' + cards + '</div>'
        + '<p class="nn-empty__sub"><strong>Subscribe and save 10%</strong> on every order. Choose it on any product page.</p>'
        + '</div>';

      targets.forEach(function (el) {
        el.innerHTML = html;
        bindCardEvents(el);
      });
    });
  }

  /* ---------- upsell ---------- */

  function renderUpsell(cart) {
    var container = document.querySelector('[data-cart-upsell]');
    if (!container) return;

    var items     = cart.items || [];
    var cartTotal = cart.total_price;

    if (items.length === 0) { container.innerHTML = ''; return; }

    var deliveryHtml = buildDeliveryLine(cartTotal, cart.total_weight);
    var rules        = getRules(items);
    var planName     = cartPlanName(cart);

    if (rules.length === 0) { container.innerHTML = deliveryHtml; return; }

    Promise.all(rules.map(function (rule) {
      return getProduct(rule.handle).then(function (p) { return { rule: rule, product: p }; });
    })).then(function (results) {
      var valid = results.filter(function (r) { return r.product !== null; });
      if (valid.length === 0) { container.innerHTML = deliveryHtml; return; }

      var cardsHtml = valid.map(function (r) { return buildCard(r.rule, r.product, planName); }).join('');
      container.innerHTML = deliveryHtml
        + '<div class="nn-up__section">'
        + '<p class="nn-up__heading">' + CONFIG.heading + '</p>'
        + '<div class="nn-up__cards">' + cardsHtml + '</div>'
        + '</div>';

      bindCardEvents(container);
    });
  }

  function bindCardEvents(root) {
    root.querySelectorAll('[data-nn-add]').forEach(function (btn) {
      btn.addEventListener('click', handleAdd);
    });
    root.querySelectorAll('[data-nn-upgrade]').forEach(function (btn) {
      btn.addEventListener('click', handleUpgrade);
    });
    root.querySelectorAll('[data-nn-option]').forEach(function (sel) {
      sel.addEventListener('change', handleOptionChange);
    });
  }

  function getRules(cartItems) {
    var h = CONFIG.handles;

    var inCartByHandle = {};
    cartItems.forEach(function (item) { inCartByHandle[item.handle] = item; });

    var cats = {
      creatine:   null,
      protein:    false,
      proteinLine: null,
      greensLine: null,
      magnesiumLine: null,
      zma:        false,
      magnesium:  false,
      omega3:     false,
      brainPower: false,
      zinc:       false,
      vitaminD:   false,
      sampleBox:  false,
      greens:     false,
      enzymes:    false,
      probiotics: false,
      scoop:      false,
    };

    cartItems.forEach(function (item) {
      var t = (item.product_title || item.title || '').toLowerCase();
      /* A 30g size of a full product (e.g. whey isolate 30g) counts as a sample, not protein */
      if (/(^|[^0-9])30g\b/i.test(item.variant_title || '') || (item.product_title || '').toLowerCase().indexOf('sample') !== -1) { cats.sampleBox = true; return; }
      if (t.indexOf('creatine') !== -1)                              cats.creatine   = item;
      if (t.indexOf('whey') !== -1 || t.indexOf('vegan protein') !== -1 ||
          (t.indexOf('protein') !== -1 && t.indexOf('sample') === -1 &&
           t.indexOf('bar') === -1)) {
        cats.protein = true;
        if (!cats.proteinLine) cats.proteinLine = item;
      }
      if (t.indexOf('zma') !== -1)                                   cats.zma        = true;
      if (t.indexOf('magnesium') !== -1 && t.indexOf('zma') === -1) { cats.magnesium = true; if (!cats.magnesiumLine) cats.magnesiumLine = item; }
      if (t.indexOf('omega') !== -1 || t.indexOf('fish oil') !== -1) cats.omega3     = true;
      if (t.indexOf('brain') !== -1 || t.indexOf('nootropic') !== -1) cats.brainPower = true;
      if (t.indexOf('zinc') !== -1 && t.indexOf('zma') === -1)      cats.zinc       = true;
      if (t.indexOf('vitamin d') !== -1 || t.indexOf('vit d') !== -1 ||
          (t.indexOf('vitamin') !== -1 && t.indexOf(' d') !== -1))  cats.vitaminD   = true;
      if (t.indexOf('sample') !== -1)                                cats.sampleBox  = true;
      if (t.indexOf('green') !== -1) { cats.greens = true; if (!cats.greensLine) cats.greensLine = item; }
      if (t.indexOf('digestive') !== -1 || t.indexOf('enzyme') !== -1) cats.enzymes   = true;
      if (t.indexOf('probiotic') !== -1)                             cats.probiotics = true;
      if (t.indexOf('scoop') !== -1)                                 cats.scoop      = true;
    });

    function cross(handle, extra) {
      var r = { type: 'cross', handle: handle };
      for (var k in (extra || {})) r[k] = extra[k];
      return r;
    }

    function notCreatine()  { return !cats.creatine; }
    function notZma()       { return !cats.zma; }
    function notMagnesium() { return !cats.magnesium; }
    function notOmega3()    { return !cats.omega3; }
    function notBrainPower(){ return !cats.brainPower; }
    function notZinc()      { return !cats.zinc; }
    function notVitaminD()  { return !cats.vitaminD; }
    function notInCart(handle) { return !inCartByHandle[handle]; }

    var rules = [];

    function upgradeIf(item, from, to) {
      if (item && new RegExp('(^|\\/\\s*)' + from + '\\b', 'i').test(item.variant_title || '')) {
        rules.push({ type: 'upgrade', handle: item.handle, line: item, to: to });
      }
    }

    /* Rules for the best sellers are built from what their buyers actually add
       (order line items, Apr to Oct 2026). See the site-and-cro plan doc. */

    /* PROTEIN IN CART (up to three cards) */
    if (cats.protein) {
      var pl = cats.proteinLine;
      var isVegan = pl && (pl.handle === h.veganVanilla || pl.handle === h.veganChocolate);
      if (pl && (isVegan || pl.handle === h.wheyIsolate || pl.handle === h.wheyConcentrate)) upgradeIf(pl, '300g', '1kg');
      if (isVegan) {
        /* Vegan buyers most often add the other flavour */
        var other = pl.handle === h.veganVanilla ? h.veganChocolate : h.veganVanilla;
        if (notInCart(other)) rules.push(cross(other, {
          label: other === h.veganVanilla ? 'Vegan Protein, Vanilla' : 'Vegan Protein, Chocolate',
          note: 'Keep both flavours in the cupboard.' }));
        if (notCreatine()) rules.push(cross(h.creatine));
        if (!cats.greens && rules.length < 3) rules.push(cross(h.supremeGreens));
        return rules.slice(0, 3);
      }
      if (notCreatine()) rules.push(cross(h.creatine));
      if (!cats.scoop) rules.push(cross(h.scoop, { size: '30g Protein', label: 'Beech protein scoop (30g)' }));
      if (notZma() && rules.length < 3) rules.push(cross(h.zma));
      return rules.slice(0, 3);
    }

    /* SUPREME GREENS (up to three cards): 300g -> 600g, creatine, the greens scoop, whey */
    if (cats.greens) {
      upgradeIf(cats.greensLine, '300g', '600g');
      if (notCreatine()) rules.push(cross(h.creatine));
      if (!cats.scoop) rules.push(cross(h.scoop, { size: '10g Greens', label: 'Beech greens scoop (10g)' }));
      if (rules.length < 3) rules.push(cross(h.wheyIsolate));
      return rules.slice(0, 3);
    }

    /* GUT HEALTH */
    if (cats.greens || cats.enzymes || cats.probiotics) {
      if (!cats.greens)    rules.push(cross(h.supremeGreens));
      if (!cats.enzymes)   rules.push(cross(h.digestiveEnzymes));
      if (!cats.probiotics && rules.length < 2) rules.push(cross(h.probiotics));
      if (rules.length === 0) {
        if (notVitaminD()) rules.push(cross(h.vitaminD));
        if (notOmega3() && rules.length < 2) rules.push(cross(h.omega3));
      }
      return rules.slice(0, 2);
    }

    /* CREATINE, NO PROTEIN (up to three cards):
       1. 150g -> 300g upgrade, when they have the small tub.
       2. Whey Isolate as a full product (300g by default, any flavour or size,
          with the 30g sample still in the size menu). Whey is the most common
          product added to creatine orders, and the sample alone capped the cart at £3.99.
       3. ZMA, a second full-price training product.
       4. The scoop, only if there is still room. */
    if (cats.creatine && !cats.protein) {
      var line = cats.creatine;
      if (line.handle === h.creatine && /150g/i.test(line.variant_title || '')) {
        rules.push({ type: 'upgrade', handle: h.creatine, line: line, to: '300g' });
      }
      if (!cats.sampleBox) {
        rules.push(cross(h.wheyIsolate, { label: 'Whey Isolate',
          note: 'Our best seller. Pick 30g in the size menu to try one serving first.' }));
      }
      if (notZma()) rules.push(cross(h.zma));
      if (!cats.scoop && rules.length < 3) {
        rules.push(cross(h.scoop, { size: 'Creapure', label: 'Beech creatine scoop (5g)' }));
      }
      return rules.slice(0, 3);
    }

    /* ZMA */
    if (cats.zma) {
      if (notMagnesium()) rules.push(cross(h.magnesium));
      if (notCreatine() && rules.length < 2) rules.push(cross(h.creatine));
      return rules.slice(0, 2);
    }

    /* MAGNESIUM (up to three cards): 90 -> 180, creatine, omega-3, vitamin D */
    if (cats.magnesium) {
      upgradeIf(cats.magnesiumLine, '90', '180');
      if (notCreatine()) rules.push(cross(h.creatine));
      if (notOmega3()) rules.push(cross(h.omega3));
      if (notVitaminD() && rules.length < 3) rules.push(cross(h.vitaminD));
      return rules.slice(0, 3);
    }

    /* BRAIN POWER */
    if (cats.brainPower) {
      if (notOmega3())    rules.push(cross(h.omega3));
      if (notMagnesium() && rules.length < 2) rules.push(cross(h.magnesium));
      return rules.slice(0, 2);
    }

    /* OMEGA 3 */
    if (cats.omega3) {
      if (notBrainPower()) rules.push(cross(h.brainPower));
      if (notMagnesium() && rules.length < 2) rules.push(cross(h.magnesium));
      return rules.slice(0, 2);
    }

    /* VITAMIN D */
    if (cats.vitaminD) {
      if (notOmega3()) rules.push(cross(h.omega3));
      if (notZinc() && rules.length < 2) rules.push(cross(h.zinc));
      return rules.slice(0, 2);
    }

    /* ZINC */
    if (cats.zinc) {
      if (notVitaminD())  rules.push(cross(h.vitaminD));
      if (notMagnesium() && rules.length < 2) rules.push(cross(h.magnesium));
      return rules.slice(0, 2);
    }

    /* SAMPLES */
    if (cats.sampleBox) {
      if (!cats.protein) rules.push(cross(h.wheyIsolate));
      if (notCreatine() && rules.length < 2) rules.push(cross(h.creatine));
      return rules.slice(0, 2);
    }

    return rules;
  }

  /* Free delivery progress bar, always shown. Under £100 a small line also gives the
     delivery cost, so it isn't a surprise at checkout. */
  function buildDeliveryLine(cartTotal, weight) {
    var threshold = CONFIG.freeDeliveryThreshold;
    var remaining = threshold - cartTotal;
    var pct      = Math.min(Math.round((cartTotal / threshold) * 100), 100);
    var unlocked = cartTotal >= threshold;
    var message  = unlocked
      ? 'Free UK delivery unlocked'
      : 'Add <strong>' + formatMoney(remaining) + '</strong> more for free UK delivery';
    /* Large letter rate applies to parcels of 10 to 50g (samples) */
    var from = (weight >= 10 && weight <= 50) ? '£2.49' : CONFIG.deliveryFromText;
    return '<div class="nn-up__progress">'
      + '<span class="nn-up__progress-label' + (unlocked ? ' nn-up__unlocked' : '') + '">' + message + '</span>'
      + '<div class="nn-up__track"><div class="nn-up__bar' + (unlocked ? ' nn-up__bar--full' : '') + '" style="width:' + pct + '%"></div></div>'
      + (unlocked ? '' : '<span class="nn-up__progress-sub">Otherwise UK delivery from ' + from + '.</span>')
      + '</div>';
  }

  /* Pack weight in grams from a variant title such as "Vanilla / 1kg" or "300g" */
  function grams(v) {
    var m = /(\d+(?:\.\d+)?)\s*(kg|g)\b/i.exec(v.title || '');
    if (!m) return 0;
    return Math.round(parseFloat(m[1]) * (m[2].toLowerCase() === 'kg' ? 1000 : 1));
  }

  /* Capsule count from a title such as "180" or "90 Capsules" */
  function capsules(v) {
    var m = /^(\d+)(\s*cap(sule)?s?)?$/i.exec((v.title || '').trim());
    return m ? parseInt(m[1], 10) : 0;
  }

  function servings(v) {
    var m = /(\d+)\s*servings/i.exec(v.title || '');
    return m ? parseInt(m[1], 10) : 0;
  }

  /* Subscription price first, one-time price struck through, when the card joins a plan */
  function cardPrice(price, pct) {
    if (!pct) return formatMoney(price);
    var sub = Math.round(price * (100 - pct) / 100);
    return '<strong class="nn-up__price-sub">' + formatMoney(sub) + '</strong> <s class="nn-up__price-was">' + formatMoney(price) + '</s>';
  }

  function buildCard(rule, product, planName) {
    var image   = product.featured_image || '';
    var handle  = product.handle;
    var imgHtml = image
      ? '<div class="nn-up__img-wrap"><img src="' + esc(image) + '" alt="' + esc(product.title) + '" class="nn-up__img" loading="lazy" width="64" height="64"></div>'
      : '';

    if (rule.type === 'upgrade') {
      var from = rule.line;
      var fromV = product.variants.filter(function (v) { return v.id === from.variant_id; })[0];
      if (!fromV) return '';
      /* Same flavour: every option that isn't the pack size must match */
      var sizeRe = /\d+(?:\.\d+)?\s*(g|kg)\b/i;
      var toV = product.variants.filter(function (v) {
        if (!v.available || (v.title || '').indexOf(rule.to) === -1) return false;
        return [1, 2, 3].every(function (i) {
          var a = fromV['option' + i];
          var b = v['option' + i] || '';
          return !a || sizeRe.test(a) || b === a || b.indexOf(rule.to) !== -1;
        });
      })[0];
      if (!toV) return '';
      var extra = toV.price - fromV.price;
      var sFrom = servings(fromV), sTo = servings(toV);
      var gFrom = grams(fromV), gTo = grams(toV);
      var lead, perServing;
      if (sFrom && sTo) {
        lead = 'Double the tub for ' + formatMoney(extra) + ' more.';
        perServing = ' ' + Math.round(toV.price / sTo) + 'p a serving instead of ' + Math.round(fromV.price / sFrom) + 'p.';
      } else if (gFrom && gTo) {
        lead = 'Get ' + rule.to + ' for ' + formatMoney(extra) + ' more.';
        perServing = ' ' + formatMoney(Math.round(toV.price * 100 / gTo)) + ' per 100g instead of ' + formatMoney(Math.round(fromV.price * 100 / gFrom)) + '.';
      } else if (capsules(fromV) && capsules(toV)) {
        lead = 'Get ' + capsules(toV) + ' capsules for ' + formatMoney(extra) + ' more.';
        perServing = ' ' + Math.round(toV.price / capsules(toV)) + 'p a capsule instead of ' + Math.round(fromV.price / capsules(fromV)) + 'p.';
      } else {
        lead = 'Go bigger for ' + formatMoney(extra) + ' more.';
        perServing = '';
      }
      var parts = (toV.title || '').split(' / ');
      var toName = parts.length > 1 ? parts[parts.length - 1] + ' ' + parts.slice(0, -1).join(' ') : toV.title;
      if (/^\d+$/.test(toName)) toName += ' capsules';
      var planId = from.selling_plan_allocation && from.selling_plan_allocation.selling_plan
        ? from.selling_plan_allocation.selling_plan.id : '';
      return '<div class="nn-up__card nn-up__card--upgrade">' + imgHtml
        + '<div class="nn-up__card-body">'
        + '<p class="nn-up__card-name">Upgrade to ' + esc(toName) + '</p>'
        + '<p class="nn-up__note">' + lead + perServing + '</p>'
        + '<button type="button" class="nn-up__btn nn-up__btn--red" data-nn-upgrade'
        + ' data-line-key="' + from.key + '" data-qty="' + from.quantity + '" data-variant-id="' + toV.id + '" data-plan="' + planId + '">'
        + 'Upgrade</button>'
        + '</div></div>';
    }

    var defaultVariant = getDefaultVariant(product, rule.size);
    if (!defaultVariant) return '';
    var name = rule.label || product.title;

    /* Add-ons join an existing subscription only when the add-on is subscribable */
    var joinPlan = null;
    if (planName && canSubscribe(name, defaultVariant.title) && canSubscribe(product.title)) joinPlan = findPlan(product, planName);

    var groups = getOptionGroups(product, rule.size);
    var selectorsHtml = '';
    if (groups.length) {
      selectorsHtml = '<div class="nn-up__selectors">';
      groups.forEach(function (group) {
        selectorsHtml += '<select class="nn-up__select" data-nn-option="' + group.index + '" aria-label="' + esc(group.name) + '">';
        group.values.forEach(function (v) {
          var isDefault = v.value === defaultVariant['option' + (group.index + 1)];
          selectorsHtml += '<option value="' + esc(v.value) + '"'
            + (isDefault ? ' selected' : '')
            + (!v.available ? ' disabled' : '')
            + '>' + esc(v.value) + '</option>';
        });
        selectorsHtml += '</select>';
      });
      selectorsHtml += '</div>';
    }

    var noteHtml = rule.note ? '<p class="nn-up__note">' + esc(rule.note) + '</p>' : '';
    var pct = joinPlan ? planPercent(joinPlan) : 0;
    var joinNote = '';
    if (joinPlan) {
      var every = (planName || '').replace(/ subscription$/i, '').toLowerCase();
      joinNote = '<p class="nn-up__note">Add to your ' + esc(every) + ' subscription' + (pct ? ' and save ' + pct + '%' : '') + ', or buy it once.</p>';
    }

    var actions = joinPlan
      ? '<button type="button" class="nn-up__btn nn-up__btn--red" data-nn-add data-label="Add to subscription" data-variant-id="' + defaultVariant.id + '" data-plan="' + joinPlan.id + '">Add to subscription</button>'
        + '<button type="button" class="nn-up__once" data-nn-add data-label="Buy once" data-variant-id="' + defaultVariant.id + '" data-plan="">Buy once</button>'
      : '<button type="button" class="nn-up__btn" data-nn-add data-label="Add to order" data-variant-id="' + defaultVariant.id + '" data-plan="">Add to order</button>'
        + '<a class="nn-up__view" href="/products/' + handle + '">View</a>';

    return '<div class="nn-up__card" data-nn-card data-handle="' + handle + '" data-size="' + esc(rule.size || '') + '" data-pct="' + pct + '">'
      + imgHtml
      + '<div class="nn-up__card-body">'
      + '<p class="nn-up__card-name">' + esc(name) + '</p>'
      + '<p class="nn-up__card-price" data-nn-price>' + cardPrice(defaultVariant.price, pct) + '</p>'
      + (joinNote || noteHtml)
      + selectorsHtml
      + '<div class="nn-up__actions">' + actions + '</div>'
      + '</div></div>';
  }

  function selectedVariant(card, product) {
    var size = card.getAttribute('data-size') || null;
    var def = getDefaultVariant(product, size);
    var selects = card.querySelectorAll('[data-nn-option]');
    if (!selects.length) return def;
    var opts = [];
    product.options.forEach(function (o, i) { opts[i] = def['option' + (i + 1)]; });
    selects.forEach(function (s) { opts[parseInt(s.getAttribute('data-nn-option'), 10)] = s.value; });
    return findVariantByOptions(product, opts, size);
  }

  function handleAdd(e) {
    var btn     = e.currentTarget;
    var card    = btn.closest('[data-nn-card]');
    var handle  = card ? card.getAttribute('data-handle') : null;
    var product = handle ? productCache[handle] : null;

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (product && card) {
      var matched = selectedVariant(card, product);
      if (matched) variantId = matched.id;
    }

    if (!variantId || isNaN(variantId)) {
      btn.textContent = 'Select options';
      return;
    }

    var body = { id: variantId, quantity: 1 };
    var plan = btn.getAttribute('data-plan');
    /* A 30g sample picked from the size menu is never added on a subscription */
    var chosen = product && product.variants.filter(function (v) { return v.id === variantId; })[0];
    if (chosen && isSampleSize(chosen)) plan = '';
    if (plan) body.selling_plan = parseInt(plan, 10);

    var original = btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(body),
    })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(data.description || data.message || 'Could not add item');
        });
      }
      btn.textContent = 'Added';
      return fullRefresh().then(reloadCartPage);
    })
    .catch(function (err) {
      btn.disabled    = false;
      btn.textContent = (err && err.message) ? err.message : original;
      setTimeout(function () {
        btn.textContent = original;
        btn.disabled    = false;
      }, 2500);
    });
  }

  /* Swap a line to a bigger size, keeping quantity and any subscription plan */
  function handleUpgrade(e) {
    var btn = e.currentTarget;
    var key = btn.getAttribute('data-line-key');
    var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    var add = { id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: qty };
    var plan = btn.getAttribute('data-plan');
    if (plan) add.selling_plan = parseInt(plan, 10);

    btn.disabled = true;
    btn.textContent = 'Upgrading...';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(add),
    })
    .then(function (r) {
      if (!r.ok) throw new Error();
      return fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: key, quantity: 0 }),
      });
    })
    .then(function () { return fullRefresh(); })
    .catch(function () { btn.disabled = false; btn.textContent = 'Upgrade'; });
  }

  function handleQtyChange(e) {
    var btn     = e.currentTarget;
    var key     = btn.getAttribute('data-key');
    var delta   = parseInt(btn.getAttribute('data-delta'), 10);
    var item    = btn.closest('.nn-item');
    var qtyEl   = item && item.querySelector('.nn-item__qty-num');
    var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var newQty  = Math.max(0, current + delta);
    btn.disabled = true;

    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: key, quantity: newQty }),
    })
    .then(function () { return fullRefresh(); })
    .catch(function () { btn.disabled = false; });
  }

  function handleRemove(e) {
    var btn = e.currentTarget;
    var key = btn.getAttribute('data-key');
    btn.disabled = true;

    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: key, quantity: 0 }),
    })
    .then(function () { return fullRefresh(); })
    .catch(function () { btn.disabled = false; });
  }

  function handleOptionChange(e) {
    var sel     = e.currentTarget;
    var card    = sel.closest('[data-nn-card]');
    if (!card) return;

    var product = productCache[card.getAttribute('data-handle')];
    if (!product) return;

    var matched = selectedVariant(card, product);
    var priceEl = card.querySelector('[data-nn-price]');
    var pct     = parseInt(card.getAttribute('data-pct'), 10) || 0;
    var btns    = card.querySelectorAll('[data-nn-add]');

    if (matched) {
      /* A 30g sample is never subscribed, so on a "join your subscription" card it
         shows its one-time price, one plain button, and no subscription note. */
      var sample = pct && isSampleSize(matched);
      if (priceEl) priceEl.innerHTML = cardPrice(matched.price, sample ? 0 : pct);
      var note = pct ? card.querySelector('.nn-up__note') : null;
      if (note) note.style.display = sample ? 'none' : '';
      btns.forEach(function (b) {
        var once = b.classList.contains('nn-up__once');
        b.style.display = (sample && once) ? 'none' : '';
        var label = sample ? 'Add to order' : (b.getAttribute('data-label') || 'Add to order');
        b.disabled    = !matched.available;
        b.textContent = matched.available ? label : 'Out of stock';
      });
    } else {
      btns.forEach(function (b) { b.disabled = true; b.textContent = 'Unavailable'; });
    }
  }

  /* The /cart page renders its line items server-side, so reload it after an add. */
  function reloadCartPage() {
    if (location.pathname.indexOf('/cart') === 0) location.reload();
  }

  var isRefreshing  = false;
  var refreshQueued = false;

  function fullRefresh() {
    if (isRefreshing) {
      refreshQueued = true;
      return Promise.resolve();
    }
    isRefreshing = true;

    return getCart().then(function (cart) {
      syncEmptyState(cart);
      renderCartItems(cart);
      ensureUpsellContainer();
      renderUpsell(cart);
    }).then(function () {
      isRefreshing = false;
      if (refreshQueued) {
        refreshQueued = false;
        fullRefresh();
      }
    }).catch(function () {
      isRefreshing = false;
    });
  }

  var scheduleTimer = null;
  function scheduleRefresh() {
    clearTimeout(scheduleTimer);
    scheduleTimer = setTimeout(fullRefresh, 60);
  }

  /* The upsell block lives inside .drawer__scrollable (below the item list) so
     the fixed footer stays down to subtotal and checkout. */
  function ensureUpsellContainer() {
    var scrollable = document.querySelector('.drawer__scrollable');
    var existing   = document.querySelector('[data-cart-upsell]');

    if (scrollable) {
      if (existing) {
        if (existing.parentElement !== scrollable) scrollable.appendChild(existing);
        return;
      }
      var div = document.createElement('div');
      div.id = 'nn-cart-upsell';
      div.setAttribute('data-cart-upsell', '');
      div.setAttribute('aria-live', 'polite');
      scrollable.appendChild(div);
      return;
    }

    if (existing) return;

    var target = document.querySelector('.cart__checkout--drawer')
              || document.querySelector('[name="checkout"]');
    if (target) {
      var div2 = document.createElement('div');
      div2.id = 'nn-cart-upsell';
      div2.setAttribute('data-cart-upsell', '');
      div2.setAttribute('aria-live', 'polite');
      target.parentNode.insertBefore(div2, target);
    }
  }

  var eventsBound = false;
  function bindEvents() {
    if (eventsBound) return;
    eventsBound = true;

    ['cart:refresh', 'cart:updated', 'cart:item-added'].forEach(function (name) {
      document.addEventListener(name, scheduleRefresh);
    });

    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type === 'attributes') {
            var isOpen = !drawer.hasAttribute('hidden')
                      && drawer.style.display !== 'none'
                      && !drawer.classList.contains('is-hidden');
            if (isOpen) scheduleRefresh();
            break;
          }
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden', 'hidden'] });

      var scrollRegion = drawer.querySelector('.drawer__scrollable') || drawer.querySelector('.cart__footer');
      if (scrollRegion) {
        new MutationObserver(function () {
          if (!document.querySelector('[data-cart-upsell]')) {
            ensureUpsellContainer();
            scheduleRefresh();
          }
        }).observe(scrollRegion, { childList: true });
      }
    }
  }

  injectStyles();

  /* Product page enhancements live in their own asset, loaded from the same folder.
     Bump PDP_VERSION whenever nn-pdp.js changes so browsers and the CDN fetch the new file. */
  var PDP_VERSION = '2026-10-08b';
  (function loadPdp() {
    if (location.pathname.indexOf('/products/') === -1) return;
    var me = document.currentScript || [].slice.call(document.scripts).filter(function (s) { return /cart-upsell\.js/.test(s.src); })[0];
    if (!me || !me.src) return;
    var s = document.createElement('script');
    s.src = me.src.replace(/cart-upsell\.js(\?[^#]*)?/, 'nn-pdp.js?v=' + PDP_VERSION);
    s.defer = true;
    document.head.appendChild(s);
  })();

  function init() {
    bindEvents();
    fullRefresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
